import type { RouteObject } from 'react-router';
import { AutomationPage } from './AutomationPage';
import { SequenceDetailPage } from './SequenceDetailPage';

export const routes: RouteObject[] = [
  { path: '/automation', element: <AutomationPage /> },
  { path: '/automation/sequences/:id', element: <SequenceDetailPage /> },
];
